const countryFlags = {
  'US': '🇺🇸',
  'CA': '🇨🇦',
  'FR': '🇫🇷',
  'NL': '🇳🇱',
  'DE': '🇩🇪',
  'GB': '🇬🇧',
  'IT': '🇮🇹',
  'ES': '🇪🇸',
  'CN': '🇨🇳',
  'JP': '🇯🇵',
  'BR': '🇧🇷',
  'IN': '🇮🇳',
  'RU': '🇷🇺',
  'ZA': '🇿🇦',
  'AU': '🇦🇺',
  'NZ': '🇳🇿',
  'MX': '🇲🇽',
  'AR': '🇦🇷',
  'CL': '🇨🇱',
  'CO': '🇨🇴',
  'PE': '🇵🇪',
  'VE': '🇻🇪',
  'EC': '🇪🇨',
  'GT': '🇬🇹',
  'HN': '🇭🇳',
  'SA': '🇸🇦',
  'AE': '🇦🇪',
  'TR': '🇹🇷',
  'TH': '🇹🇭',
  'MY': '🇲🇾',
  'SG': '🇸🇬',
  'ID': '🇮🇩',
  'PH': '🇵🇭',
  'VN': '🇻🇳',
  'KR': '🇰🇷',
  'KP': '🇰🇵',
  'SE': '🇸🇪',
  'NO': '🇳🇴',
  'FI': '🇫🇮',
  'DK': '🇩🇰',
  'IS': '🇮🇸',
  'IE': '🇮🇪',
  'CH': '🇨🇭',
  'PT': '🇵🇹',
  'BE': '🇧🇪',
  'LU': '🇱🇺',
  'PL': '🇵🇱',
  'CZ': '🇨🇿',
  'SK': '🇸🇰',
  'HU': '🇭🇺',
  'AT': '🇦🇹',
  'LI': '🇱🇮',
  'GR': '🇬🇷',
  'BG': '🇧🇬',
  'RO': '🇷🇴',
  'UA': '🇺🇦',
  'BY': '🇧🇾',
  'LT': '🇱🇹',
  'LV': '🇱🇻',
  'EE': '🇪🇪',
  'MD': '🇲🇩',
  'AM': '🇦🇲',
  'GE': '🇬🇪',
  'AZ': '🇦🇿',
  'IR': '🇮🇷',
  'IQ': '🇮🇶',
  'SY': '🇸🇾',
  'LB': '🇱🇧',
  'JO': '🇯🇴',
  'IL': '🇮🇱',
  'EG': '🇪🇬',
  'MA': '🇲🇦',
  'DZ': '🇩🇿',
  'TN': '🇹🇳',
  'LY': '🇱🇾',
  'GM': '🇬🇲',
  'SN': '🇸🇳',
  'MR': '🇲🇷',
  'ML': '🇲🇱',
  'GN': '🇬🇳',
  'CI': '🇨🇮',
  'BF': '🇧🇫',
  'NE': '🇳🇪',
  'TG': '🇹🇬',
  'BJ': '🇧🇯',
  'NG': '🇳🇬',
  'CM': '🇨🇲',
  'GA': '🇬🇦',
  'CG': '🇨🇬',
  'CD': '🇨🇩',
  'AO': '🇦🇴',
  'GW': '🇬🇼',
  'SC': '🇸🇨',
  'SD': '🇸🇩',
  'RW': '🇷🇼',
  'ET': '🇪🇹',
  'SO': '🇸🇴',
  'DJ': '🇩🇯',
  'KE': '🇰🇪',
  'TZ': '🇹🇿',
  'UG': '🇺🇬',
  'BI': '🇧🇮',
  'MZ': '🇲🇿',
  'ZM': '🇿🇲',
  'MW': '🇲🇼',
  'LS': '🇱🇸',
  'BW': '🇧🇼',
  'NA': '🇳🇦',
  'ZA': '🇿🇦',
  'SZ': '🇸🇿',
  'PK': '🇵🇰'
};


const LOCATION_STORAGE_KEY = 'userLocationInfo';

function setLocationInfo(countryCode, countryName) {
  const flagEmoji = countryFlags?.[countryCode];

  document.body.style.setProperty(
    '--shipping-cntry-emoji-cstmm',
    `"${flagEmoji}"`
  );

  document.body.style.setProperty(
    '--shipping-message-cstmm',
    `"${countryName}"`
  );

  // Save to localStorage
  localStorage.setItem(
    LOCATION_STORAGE_KEY,
    JSON.stringify({ countryCode, countryName })
  );
}

function loadLocationFromStorage() {
  const stored = localStorage.getItem(LOCATION_STORAGE_KEY);
  if (!stored) return;

  try {
    const { countryCode, countryName } = JSON.parse(stored);
    if (countryName) {
      setLocationInfo(countryCode, countryName);
    }
  } catch (e) {
    console.warn('Invalid location data in localStorage');
  }
}

async function fetchLocationInfo() {
  try {
    const response = await fetch('/browsing_context_suggestions.json');
    const data = await response.json();

    const countryCode = data.detected_values.country.handle;
    const countryName = data.detected_values.country.name;

    // Only update if different from stored value
    const stored = localStorage.getItem(LOCATION_STORAGE_KEY);
    const storedData = stored ? JSON.parse(stored) : {};

    if (
      storedData.countryCode !== countryCode ||
      storedData.countryName !== countryName
    ) {
      setLocationInfo(countryCode, countryName);
    }
  } catch (error) {
    console.error('Error fetching location info:', error);
  }
}

loadLocationFromStorage();
fetchLocationInfo();



